// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel.attributeTypeMap = [
    {
        "name": "contactInfoType",
        "baseName": "contactInfoType",
        "type": "ContactInfoType"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    }
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel.js.map